module.exports = __webpack_public_path__ + "img/Fashion.90d925a9.jpg";